"use strict";

var modal = $('.modal');
function modalOpen() {
  modal.addClass('modal--offstage'), setTimeout(function () {
    modal.addClass('modal--visible');
  }, 20);
}
function modalClose() {
  modal.removeClass('modal--visible'), setTimeout(function () {
    modal.removeClass('modal--offstage');
  }, 20);
}
$('.js-location-link').click(function (e) {
  e.preventDefault();
  var location = $(this),
    href = location.attr('href'),
    companyLink = href.replace(/https?:\/\/(www\.)?/, '');
  $('.location-title').html(location.data('title'));
  $('.location-location').html(location.data('location'));
  $('.location-about').html(location.data('about'));
  $('.location-href').attr('href', href);
  modalOpen();
});
$('.modal').click(function () {
  modalClose();
});
$('.modal-close').click(function (e) {
  e.preventDefault();
  modalClose();
  $('#video').attr('src', '');
});
$('body').keydown(function (e) {
  if (e.keyCode === 27 || e.keyCode === 27) {
    modalClose();
    e.preventDefault();
  }
});
$('.js-video-toggle').click(function (e) {
  modalOpen();
  var videoSrc = $(this).data('src');
  $('#video').attr('src', videoSrc);
  $('#video')[0].src += '&autoplay=1';
  e.preventDefault();
});
$('.modal').click(function () {
  modalClose();
  $('#video').attr('src', '');
});
if (!Modernizr.svg) {
  $('img[src*="svg"]').attr('src', function () {
    return $(this).attr('src').replace('.svg', '.png');
  });
}
$('#site-head').headroom({
  tolerance: {
    up: 10,
    down: 5
  }
});

/*** Scroll funtimes ***/
$('.js-animate').addClass('is-active');

/*** FAQ accordiion ***/
$('.question').click(function () {
  $header = $(this);
  //getting the next element
  $content = $header.next();
  //open up the content needed - toggle the slide- if visible, slide up, if not slidedown.
  $content.toggleClass('collapsed');
  $header.toggleClass('open');
});

//callout
var closebtn = $('.close-callout');
closebtn.click(function (e) {
  //  toggler.addClass("collapsed");
  $('body').removeClass('callout-active');
  document.cookie = 'calloutStatus=hide;path=/';
  e.preventDefault();
});
$('.testimonial-slider').flickity({
  wrapAround: true,
  pageDots: false,
  arrowShape: {
    x0: 0,
    x1: 70,
    y1: 50,
    x2: 70,
    y2: 25,
    x3: 70
  }
});

/*** AJAX Filter for Projects ***/

var streamSlugM = $('#m-streamsfilter-legacy').find(':selected').data('stream'),
  locationSlugM = $('#m-locationsfilter-legacy').find(':selected').data('location'),
  streamSlugC = $('#c-streamsfilter').find(':selected').data('stream'),
  locationSlugC = $('#c-locationsfilter').find(':selected').data('location'),
  cohortSlug = $('#cohortsfilter').find(':selected').data('cohort'),
  roleSlug = $('#rolesfilter-legacy').find(':selected').data('role'),
  streamQueryM = '',
  locationQueryM = '',
  streamQueryC = '',
  locationQueryC = '',
  cohortQuery = '',
  roleQuery = '',
  searchQuery = '';
function addMentorsParams(stream, location, role) {
  // searchQuery Variable
  if (stream === 'all' && location === 'all' && role === 'all') {
    searchQuery = '';
  } else {
    searchQuery = '?';
  }
  // streamQueryM Variable
  if (stream === 'all') {
    streamQueryM = '';
  } else {
    streamQueryM = "stream=".concat(stream);
  }
  // locationQueryM Variable
  if (location === 'all') {
    locationQueryM = '';
  } else if (stream === 'all') {
    locationQueryM = "location=".concat(location);
  } else {
    locationQueryM = "&location=".concat(location);
  }
  // roleQuery Variable
  if (role === 'all') {
    roleQuery = '';
  } else if (stream === 'all' && location === 'all') {
    roleQuery = "role=".concat(role);
  } else {
    roleQuery = "&role=".concat(role);
  }
}

// function addCompaniesParams(stream, location, cohort) {
//   // searchQuery Variable
//   if (stream === 'all' && location === 'all' && cohort === 'all') {
//     searchQuery = '';
//   } else {
//     searchQuery = '?';
//   }
//   // streamQueryC Variable
//   if (stream === 'all') {
//     streamQueryC = '';
//   } else if (stream == undefined) {
//     streamQueryC = '';
//   } else {
//     streamQueryC = `stream=${stream}`;
//   }
//   // locationQueryC Variable
//   if (location === 'all') {
//     locationQueryC = '';
//   } else if (location == undefined) {
//     locationQueryC = '';
//   } else if (stream === 'all') {
//     locationQueryC = `location=${location}`;
//   } else {
//     locationQueryC = `&location=${location}`;
//   }
//   // cohortQuery Variable
//   if (cohort === 'all') {
//     cohortQuery = '';
//   } else if (cohort == undefined) {
//     cohortQuery = '';
//   } else if (stream === 'all' && location === 'all') {
//     cohortQuery = `cohort=${cohort}`;
//   } else {
//     cohortQuery = `&cohort=${cohort}`;
//   }
// }

jQuery(function ($) {
  // Mentors
  $('#m-streamsfilter-legacy').change(function () {
    streamSlugM = $(this).find(':selected').data('stream');
    addMentorsParams(streamSlugM, locationSlugM, roleSlug);
    $('#apply').click();
  });
  $('#m-locationsfilter-legacy').change(function () {
    locationSlugM = $(this).find(':selected').data('location');
    addMentorsParams(streamSlugM, locationSlugM, roleSlug);
    $('#apply').click();
  });
  $('#rolesfilter-legacy').change(function () {
    roleSlug = $(this).find(':selected').data('role');
    addMentorsParams(streamSlugM, locationSlugM, roleSlug);
    $('#apply').click();
  });
  $('#mentors-filter-legacy').submit(function () {
    var filter = $('#mentors-filter-legacy');
    $.ajax({
      url: filter.attr('action'),
      data: filter.serialize(),
      // form data
      type: filter.attr('method'),
      // POST
      success: function success(data) {
        $('#mentors-container').html(data); // insert data
        window.history.pushState('Details', 'Title', "/mentors/".concat(searchQuery).concat(streamQueryM).concat(locationQueryM).concat(roleQuery));
      }
    });
    return false;
  });

  // // Companies
  // $('#c-streamsfilter').change(function () {
  //   streamSlugC = $(this)
  //     .find(':selected')
  //     .data('stream');
  //   addCompaniesParams(streamSlugC, locationSlugC, cohortSlug);
  //   $('#apply').click();
  // });

  // $('#c-locationsfilter').change(function () {
  //   locationSlugC = $(this)
  //     .find(':selected')
  //     .data('location');
  //   addCompaniesParams(streamSlugC, locationSlugC, cohortSlug);
  //   $('#apply').click();
  // });

  // $('#cohortsfilter').change(function () {
  //   cohortSlug = $(this)
  //     .find(':selected')
  //     .data('cohort');
  //   addCompaniesParams(streamSlugC, locationSlugC, cohortSlug);
  //   $('#apply').click();
  // });

  // $('#companies-filter').submit(function () {
  //   var filter = $('#companies-filter');
  //   $.ajax({
  //     url: filter.attr('action'),
  //     data: filter.serialize(), // form data
  //     type: filter.attr('method'), // POST
  //     success: function (data) {
  //       $('#companies-container').html(data); // insert data
  //       window.history.pushState(
  //         'Details',
  //         'Title',
  //         `/companies/${searchQuery}${streamQueryC}${locationQueryC}${cohortQuery}`
  //       );
  //     }
  //   });
  //   return false;
  // });
});

if ($("div.container").hasClass("mentors-new")) {
  console.log("mentors page init");
  $('.grid').isotope({
    // options
    itemSelector: '.unit',
    layoutMode: 'fitRows'
  });
}